import { find } from 'lodash-es';
import OptionSelect from './product-option-values';
import transformOptions from '../helpers/transform-options';

export default {
  props: ['variants', 'initialVariant', 'options', 'isBisForm'],

  delimiters: ['#{', '}'],
  components: {
    'option-select': OptionSelect,
  },
  data: function () {
    return {
      selectedVariant: this.initialVariant,
      colorsAsProducts: window.theme.settings.colors_as_products,
    }
  },

  methods: {
    selectedOptionValue(option) {
      return this.selectedOptions['option' + option.position]
    },

    optionChanged(option, value) {
      const newOptions = Object.assign({}, this.selectedOptions)
      const key = 'option' + option.position
      newOptions[key] = value

      const selectedVariant = this.getVariantByOptions(newOptions)
      if (selectedVariant !== undefined) this.selectedVariant = selectedVariant
    },

    getVariantByID(id){
      return find(this.variants, v => { return v.id == id })
    },

    getVariantByOptions(options){
      return find(this.variants, options)
    },
  },

  watch: {
    selectedVariant(variant) {
      this.$emit('variant-changed', variant)
    }
  },

  computed: {
    selectedOptions() {
      return this.transformedOptions.reduce((acc, option) => {
        const key = 'option' + option.position
        acc[key] = this.selectedVariant[key]
        return acc
      }, {})
    },

    transformedOptions() {
      return transformOptions(this.options, this.variants)
    },

    selectedVariantID: {
      get() {
        return this.selectedVariant.id
      },

      set(id) {
        const selectedVariant = this.getVariantByID(id)
        if (selectedVariant !== undefined) this.selectedVariant = selectedVariant
      }
    }
  },
  template: `
    <div class="js f aic f-wrap jcb space-y-5" v-if="variants.length > (isBisForm ? 0 : 1)">
      <template v-for="option in transformedOptions">
        <div class="flex flex-col" :class="{'items-center': isBisForm}" v-if="!(colorsAsProducts && option.name.toLowerCase() == 'color')">
          <label class="text-sm">#{option.name}</label>
          <option-select
            :option="option"
            :selectedValue="selectedOptionValue(option)"
            :diagonal-strike="option.name == 'size' || option.name == 'Size'"
            :isBisForm="isBisForm"
            @change="optionChanged">
          </option-select>

        </div>
      </template>
      <noscript>
        <select name="id" v-model="selectedVariantID">
          <template v-for="variant in variants">
            <option
              :value="variant.id"
              :disabled="variant.available !== true">
                #{ variant.title }
            </option>
          </template>
        </select>
      </noscript>
    </div>
  `
}
